export var ROWS_ITEMS = [10, 15, 25, 50];

export var mcciCommercialBusinessIds = [1520, // CONTRATISTAS GENERALES – RESIDENCIAL Y COMERCIAL
4011, // TRENES
4111, // TRANSPORTE LOCAL Y SUBURBANO DE PASAJEROS QUE RECORREN LA MISMA RUTA DIARIAMENTE, INCLUYENDO TRASBORDADORES
4112, // TRENES DE PASAJEROS
4119, // SERVICIOS DE AMBULANCIAS
4121, // SERVICIO DE TAXIS Y LIMOSINAS
4131, // LÍNEAS DE AUTOBUSES
4214, // PORTADORES MOTORIZADOS DE CARGA Y TRANSPORTE DE MERCANCÍAS – LOCAL Y LARGA DISTANCIA, COMPAÑÍAS DE RETIRO Y ALMACENAJE, Y SERVICIOS LOCALES DE ENTREGA
4215, // SERVICIOS DE ENVÍO – AÉREOS Y TERRESTRE Y REENVÍO DE CARGA
4411, // NAVÍOS A VAPOR Y LÍNEAS DE CRUCERO
4457, // ALQUILER Y ARRENDAMIENTO DE BOTES
4468, // MUELLES, SERVICIOS MARÍTIMOS Y SUMINISTROS
4511, // AEROLÍNEAS Y TRANSPORTE AÉREO – NO CLASIFICADO EN OTRO MCC
4722, // AGENCIAS DE VIAJE Y OPERADORES TURÍSTICOS
5045, // COMPUTADORAS, EQUIPOS PERIFERICOS Y SOFTWARE PARA COMPUTADORAS
5251, // FERRETERÍAS
5300, // CLUBES MAYORISTAS
5399, // MERCADERÍA MISCELÁNEA (BAZARES Y TIENDAS DE REGALO)
5499, // TIENDAS MISCELÁNEAS DE COMIDA – TIENDAS DE CONVENIENCIA Y MERCADOS ESPECIALIZADOS
5511, // COMERCIANTES DE AUTOS Y CAMIONES (NUEVOS Y USADOS) VENTAS, SERVICIO, REPARACIONES, PARTES Y ARRENDAMIENTO
5521, // COMERCIANTES DE AUTOS Y CAMIONES (SÓLO USADOS) VENTAS, SERVICIO, REPARACIONES, PARTES Y ARRENDAMIENTO
5533, // TIENDAS DE PARTES Y ACCESORIOS AUTOMOTRICES
5621, // TIENDAS DE ROPA LISTA PARA USAR PARA DAMAS
5719, // TIENDAS DE ESPECIALIDAD PARA IMPLEMENTACIÓN MISCELÁNEA DEL HOGAR (TIENDAS DE DECORACION EN GENERAL)
5732, // TIENDAS DE ELECTRÓNICOS
5734, // TIENDAS DE SISTEMAS PARA COMPUTADORAS.
5811, // SERVICIO DE CATERING (PROVEEDORES PARA FIESTAS Y BANQUETES
5812, // LUGARES PARA COMER Y RESTAURANTES (RESTAURANTES)
5940, // TIENDAS DE BICICLETAS - VENTAS Y SERVICIOS
5944, // TIENDAS DE JOYAS, RELOJES PEQUEÑOS, RELOJES GRANDES Y PLATERÍA
5970, // TIENDAS DE SUMINISTROS PARA ARTISTAS Y ARTESANÍAS
6012, // INSTITUCIONES FINANCIERAS – MERCANCIA Y SERVICIOS
6300, // VENTAS DE SEGUROS, GARANTÍAS Y PRIMAS
6513, // AGENTES DE BIENES INMOBILIARIOS - ALQUILER
7011, // HOSPEDAJE - HOTELES, MOTELES, CENTROS TURÍSTICOS, SERVICIOS DE CENTRALES DE RESERVAS (NO CLASIFICADO EN OTRO MCC).
7311, // SERVICIOS DE PUBLICIDAD
7392, // SERVICIOS DE ADMINISTRACIÓN, CONSULTORÍA Y RELACIONES PÚBLICAS
7399, // SERVICIOS DE NEGOCIOS (NO CLASIFICADOS EN OTRO MCC (CONGRESOS Y EVENTOS, ACTIVIDADES NO CLASIFICADAS)
7512, // AGENCIAS DE ALQUILER DE AUTOS
8011, // DOCTORES Y MÉDICOS – NO CLASIFICADOS EN OTRO MCC
8021, // DENTISTAS Y ORTODONCISTAS
8062, // HOSPITALES (CLINICAS Y CENTROS MEDICOS)
8099, // SERVICIOS MÉDICOS Y PRACTICANTES DE LA SALUD – NO CLASIFICADOS EN OTRO MCC
8220, // UNIVERSIDADES, ESCUELAS PROFESIONALES, INSTITUTOS (SOLO ENTIDADES DE EDUCACIÓN SUPERIOR)
8241, // ESCUELAS A DISTANCIA
8299, // ESCUELAS Y SERVICIOS EDUCACIONALES (NO CLASIFICADOS EN OTROS MCC)
8398, // ORGANIZACIONES CARITATIVAS Y SERVICIOS SOCIALES (ORGANIZACIONES SIN FINES DE LUCRO)
8641 // ASOCIACIONES CÍVICAS, SOCIALES Y FRATERNALES Y COLEGIOS PROFESIONALES
];

export var emailDomains = ['aol.com', 'gmail.com', 'gmx.com', 'mail.com', 'outlook.com', 'hotmail.com', 'yahoo.com', 'yahoo.es'];

export var corporateSegment = ['B', 'G', 'P', 'V'];

export var chooseDescMCCNacional = ['Venta Extendida', 'MULTICOMERCIO BIMONEDA FIJO', //[POS Inalambrico y POS Fijo Internet] alquiler   masivo 
'Multicomercio', //[POS Inalambrico y POS Fijo Internet] alquiler corporativo 
'Venta VN', //POS Inalambrico venta masivo y corporativo
'DELIVERY REGULAR'];


//////////////////
// WEBPACK FOOTER
// ./src/constants.js
// module id = ./src/constants.js
// module chunks = 34